import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
    {
        title: "Tell us what you need",
        body: "A vendor proposal, an unclear set of requirements, an upcoming go-live, or an AI rollout — send us the details or book a short call.",
    },
    {
        title: "We agree scope and days",
        body: "You get a day count and an estimate before any work starts — charges based on each professional's day rate.",
    },
    {
        title: "You get a clear outcome",
        body: "A written report, a sign-off, or a documented recommendation — always something concrete you can act on or show stakeholders.",
    },
];

export default function HowItWorks() {
    return (
        <section id="how">
            <div className="wrap">
                <motion.div
                    className="section-head"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: EASE }}
                >
                    <div>
                        <h2>How an engagement works</h2>
                    </div>
                    <p className="section-desc">
                        Straightforward and fixed-scope, so you know the cost
                        and timeline before we start.
                    </p>
                </motion.div>

                <motion.div
                    className="steps-progress"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 1.4, ease: EASE }}
                />

                <div className="steps">
                    {STEPS.map((step, i) => (
                        <motion.div
                            className="step"
                            key={i}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{
                                duration: 0.7,
                                ease: EASE,
                                delay: i * 0.12,
                            }}
                        >
                            <div className="step-index">STEP {i + 1}</div>
                            <h3>{step.title}</h3>
                            <p>{step.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
